import { Component } from "react";

import { IoAddOutline, IoCheckmarkCircle } from "react-icons/io5";
import "../styles/programs_accordion.css";

class ProgramsAccordion extends Component {
  render() {
    const programsData = [
      {
        id: "aero",
        title: "Aero Modeling",
        subtitle:
          "Hands-on learning that introduces students to the science of flight, aircraft design, and real-world aeronautical problem-solving.",
        basicDesc:
          "Students learn fundamental flight principles, build simple models, and explore how aircraft work through guided activities.",
        basicPoints: [
          "Basics of Flight & Aerodynamics",
          "Aircraft Parts & Functions",
          "Hands-on introduction to design–test–iterate cycle",
        ],
        advanceDesc:
          "Deepens technical understanding with advanced aerodynamics, RC model concepts, and engineering-level design.",
        advancePoints: [
          "Advanced Aerodynamics & Wing Design",
          "Propulsion & Control Systems",
          "Prototype Building & Flight Testing",
        ],
      },
      {
        id: "arts",
        title: "Arts",
        subtitle:
          "A program that develops creativity, visual expression, and artistic confidence through hands-on exploration across multiple art forms.",
        basicDesc:
          "Students explore essential art techniques, color theory, and creative expression through simple yet engaging activities.",
        basicPoints: [
          "Fundamentals of Drawing",
          "Color Theory & Painting",
          "Creative Craft & Composition",
        ],
        advanceDesc:
          "Students refine their artistic identity, explore mediums, and create portfolio-worthy pieces.",
        advancePoints: [
          "Advanced Illustration & Sketching",
          "Mixed Media & Digital Art",
          "Art Portfolio & Exhibition Piece",
        ],
      },
      {
        id: "coding",
        title: "Coding",
        subtitle:
          "Preparing students for the digital future through hands-on coding, logic-building, and app/AI fundamentals.",
        basicDesc:
          "Introduces coding logic, block-based programming, and the fundamentals of creating apps and simple AI.",
        basicPoints: [
          "Coding Logic & Algorithms",
          "App Development Basics",
          "AI & Chatbot Creation",
        ],
        advanceDesc:
          "Students dive into Python, automation, data handling, and real-world coding applications",
        advancePoints: [
          "Python Fundamentals",
          "Data & Automation",
          "Advanced App & AI Projects",
        ],
      },
      {
        id: "comms",
        title: "Communication",
        subtitle:
          "Developing strong speaking, writing, and presentation skills for academic and real-world success.",
        basicDesc:
          "Students build confidence in speaking, storytelling, and core communication skills.",
        basicPoints: [
          "Speaking Confidence",
          "Storytelling & Creative Writing",
          "Presentation Basics",
        ],
        advanceDesc:
          "Focused on persuasive speaking, debate, media communication, and real-world presentation mastery.",
        advancePoints: [
          "Debate & Critical Thinking",
          "Professional Writing",
          "Public Speaking Mastery",
        ],
      },
      {
        id: "des",
        title: "Design Thinking",
        subtitle:
          "A problem-solving framework encouraging creativity, empathy, and innovation.",
        basicDesc:
          "Students learn to observe, empathize, brainstorm, and build simple solutions.",
        basicPoints: [
          "Empathy & Problem Framing",
          "Ideation Techniques",
          "Prototyping Basics",
        ],
        advanceDesc:
          "Advanced prototyping, testing, and real-world innovation challenges.",
        advancePoints: [
          "Rapid Prototyping",
          "User Testing & Iteration",
          "Innovation Challenge Project",
        ],
      },
      {
        id: "elecs",
        title: "Electronics & IoT",
        subtitle:
          "A hands-on exploration of circuits, sensors, and smart connected systems.",
        basicDesc:
          "Students learn basic circuits, components, and small interactive electronics projects.",
        basicPoints: [
          "Basics of Circuits",
          "Sensors & Input Devices",
          "Mini Electronic Projects",
        ],
        advanceDesc:
          "Students build IoT systems, program microcontrollers, and create functional smart prototypes.",
        advancePoints: [
          "Microcontroller Basics",
          "IoT Connectivity",
          "Smart Device Prototype",
        ],
      },
      {
        id: "fin",
        title: "Financial Literacy",
        subtitle:
          "Equipping students with real-world money skills, budgeting, investing, and financial decision-making.",
        basicDesc:
          "Understanding money, saving habits, budgeting, and basics of personal finance.",
        basicPoints: ["Money Basics", "Budgeting Skills", "Smart Spending"],
        advanceDesc:
          "Introduces investing, entrepreneurship, and long-term financial planning.",
        advancePoints: [
          "Banking & Digital Finance",
          "Investing Basics",
          "Entrepreneurship Project",
        ],
      },
      {
        id: "rob",
        title: "Robotics & AI",
        subtitle:
          "Students build robots, understand automation, and explore foundational AI concepts.",
        basicDesc:
          "Hands-on introduction to robotics, sensors, movement, and basic automation.",
        basicPoints: [
          "Robot Basics",
          "Sensors & Control",
          "Simple Autonomous Robot",
        ],
        advanceDesc:
          "Programming robots, advanced AI models, and real-world automation projects.",
        advancePoints: [
          "Robotics Programming",
          "AI Concepts",
          "Intelligent Robot Prototype",
        ],
      },
    ];

    return (
      <section
        id="programs"
        className="py-5"
        style={{ backgroundColor: "#fff0eb27" }}
      >
        <div className="container py-lg-5" style={{ maxWidth: "1000px" }}>
          {/* Header */}
          <div className="text-center mb-5">
            <h2 className="display-5 text-dark fw-normal mb-3">Our programs</h2>
            <p
              className="text-secondary mx-auto"
              style={{ fontSize: "16px", lineHeight: "1.6", maxWidth: "900px" }}
            >
              Our approach directly addresses the urgent need to equip learners
              with adaptive, cross-disciplinary skill sets by providing a
              scalable and adaptable model for skill integration.
            </p>
          </div>

          {/* Bootstrap Accordion Container */}
          <div className="accordion xlp-accordion" id="programsAccordion">
            {programsData.map((prog) => (
              <div className="accordion-item" key={prog.id}>
                <h2 className="accordion-header" id={`heading-${prog.id}`}>
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${prog.id}`}
                  >
                    <div className="pe-4">
                      <h3 className="h4 text-dark fw-medium mb-2">
                        {prog.title}
                      </h3>
                      <p
                        className="text-secondary mb-0"
                        style={{ fontSize: "15px", maxWidth: "700px" }}
                      >
                        {prog.subtitle}
                      </p>
                    </div>

                    <div className="ms-auto icon-toggle d-flex align-items-center">
                      <IoAddOutline size={28} />
                    </div>
                  </button>
                </h2>

                <div
                  id={`collapse-${prog.id}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#programsAccordion"
                >
                  <div className="accordion-body px-4 px-lg-5 pb-5 pt-0">
                    <hr
                      className="mb-4 mt-0"
                      style={{ borderColor: "#eaeaea" }}
                    />

                    <div className="row g-5">
                      {/* Basic Column */}
                      <div className="col-md-6">
                        <h4 className="h5 text-dark mb-3">Basic</h4>
                        <p
                          className="text-secondary mb-4"
                          style={{ fontSize: "15px" }}
                        >
                          {prog.basicDesc}
                        </p>
                        <ul className="xlp-check-list">
                          {prog.basicPoints.map((point, index) => (
                            <li key={index}>
                              <IoCheckmarkCircle className="check-icon" />
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>

                      {/* Advance Column */}
                      <div className="col-md-6">
                        <h4 className="h5 text-dark mb-3">Advanced</h4>
                        <p
                          className="text-secondary mb-4"
                          style={{ fontSize: "15px" }}
                        >
                          {prog.advanceDesc}
                        </p>
                        <ul className="xlp-check-list">
                          {prog.advancePoints.map((point, index) => (
                            <li key={index}>
                              <IoCheckmarkCircle className="check-icon" />
                              {point}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default ProgramsAccordion;
